import React from 'react'

export const northCarolinaSetupVars = {
  siteId: 'north_carolina',
  pathPrefix: '/nc',
  menuHeader: "Discover North Carolina's Solution for:",
  appUrl: 'https://nc.headed2.com',
  logoImg: '/images/assets/north_carolina/horizontal/dark.svg',
  headerTitle: `The North Carolina CareerExplorer is a system designed for North Carolina`
}
